var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comments-new" }, [
    _c(
      "div",
      { staticClass: "scroll-bar", style: _vm.scrollBarStyles },
      _vm._l(_vm.items, function(comment, index) {
        return _c("div", { staticClass: "comment" }, [
          _c("div", { staticClass: "comments-heading" }, [
            _c("div", { staticClass: "name" }, [_vm._v(_vm._s(comment.name))]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: comment.rating, width: "101px", height: "15px" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text" }, [_vm._v(_vm._s(comment.text))])
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination" },
      _vm._l(_vm.items, function(slide, i) {
        return _c(
          "div",
          {
            key: "i",
            staticClass: "circle",
            class: {
              active: i == _vm.currentSlide
            }
          },
          [_vm._v("\n           \n      ")]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }